
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M8 .5C3.85784.5.5 3.85784.5 8c0 4.1422 3.35784 7.5 7.5 7.5 4.1422 0 7.5-3.3578 7.5-7.5C15.5 3.85784 12.1422.5 8 .5zM8 14c-3.30841 0-6-2.6916-6-6 0-3.30841 2.69159-6 6-6 3.3084 0 6 2.69159 6 6 0 3.3084-2.6916 6-6 6zm0-4.5c.41406 0 .75-.33594.75-.75v-4C8.75 4.33594 8.41406 4 8 4s-.75.33594-.75.75v4c0 .41406.33594.75.75.75zm0 1.0351c-.54259 0-.98244.4399-.98244.9824 0 .5426.43985.9825.98244.9825.54259 0 .98244-.4399.98244-.9825 0-.5425-.43985-.9824-.98244-.9824z"}})])
          )
        }
      }
    